import { coreInitiativesLinksByIdDeleteAsyncSlice } from './delete';
import { coreInitiativesLinksByIdPatchAsyncSlice } from './patch';

export const { requestDeleteCoreInitiativesLinksById, resetDeleteCoreInitiativesLinksById } =
	coreInitiativesLinksByIdDeleteAsyncSlice.asyncActionCreators;

export const { requestPatchCoreInitiativesLinksById, resetPatchCoreInitiativesLinksById } =
	coreInitiativesLinksByIdPatchAsyncSlice.asyncActionCreators;
